// Originalfotos der Bali-Info-Seiten (www.balivwtour.com), große Auflösung.
export const plantPhotos: Record<string, string[]> = {
  bambus: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/bamboo01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/bamboo08_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/bamboo06_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/bamboo05_large.jpg",
  ],
  chayote: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/chayote03_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/chayote02_large.jpg",
  ],
  erdnuss: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/kajang01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/kajang02_large.jpg",
  ],
  suesskartoffel: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/sweetpotato_plant01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/sweetpotato01_large.jpg",
  ],
  maniok: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/tapioka_plant02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/tapioka_root01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/tapioka_root02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/tapioka_root03_large.jpg",
  ],
  tania: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/taro_plant01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/taro01_large.jpg",
  ],
  kokospalme: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/coconut01_large.jpg",
  ],
  zuckerpalme: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/sugarpalm02_large.jpg",
  ],
  flamboyan: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/flamboyant01_large.jpg",
  ],
  taep: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/pohontaep01_large.jpg",
  ],
  frangipani: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/frangipani_flower06_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/frangipani_flower02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/frangipani_flower03_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/frangipani_flower04_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/frangipani_flower05_large.jpg",
  ],
  wuestenrose: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/wuestenrose02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/wuestenrose01_large.jpg",
  ],
  engelstrompete: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/datura_flower02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/datura_flower01_large.jpg",
  ],
  helikonie: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/heliconia02_large.jpg",
  ],
  hibiskus: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/hibiscus01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/hibiscus02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/hibiscus03_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/hibiscus04_large.jpg",
  ],
  ravenala: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/ravenala01_large.jpg",
  ],
  geweihfarn: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/geweihfarn01_large.jpg",
  ],
  keulenlilie: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/keulenlilie01_large.jpg",
  ],
  pagodenblume: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/pagodenblume01_large.jpg",
  ],
  lotus: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/lotus_flower07_large.jpg",
  ],
  seerose: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/lotus_flower05_large.jpg",
  ],
  bougainvillea: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/bougainvillie01_large.jpg",
  ],
  goldtrompete: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/goldtrompete01_large.jpg",
  ],
};
